export interface TripDetailsPageLoad {
  trips: Trips;
}

export interface Trips {
  details: TripsData;
}

export interface TripsData {
  pnr?: string;
  business_itinery?: string;
  itinerary_cabin?: string;
  hours_til_departure?: number;
  trip_type?: string;
  fly_ready_status?: string;
  messaging_status?: string;
  checkin_status?: string;
  domestic_vs_international?: string;
  product_info?: TripsProductInfo[];
}

export interface TripsProductInfo {
  origin_airport_code: string;
  destination_airport_code: string;
  departure_date: string;
  return_date?: string;
  leg?: number;
  trip_length?: number;
  days_til_departure?: number;
  hours_til_departure?: number;
  num_of_travelers?: number;
  num_of_adults?: number;
  num_of_children?: number;
  product_type?: string;
  flight_type?: string;
  ticket_type?: string;
  fare_type?: string;
  flow_type?: string;
  cabin_type?: string;
  travel_status?: string;
}
